// Form completion webhook service
import { settingsService } from './settingsService';

class FormWebhookService {
    private static instance: FormWebhookService;
    
    private constructor() {}
    
    static getInstance(): FormWebhookService {
        if (!FormWebhookService.instance) {
            FormWebhookService.instance = new FormWebhookService();
        }
        return FormWebhookService.instance;
    }
    
    /**
     * Trigger form completion webhook
     * This should be called when a customer successfully completes the contact form
     */
    async triggerFormCompletion(): Promise<boolean> {
        try {
            return await settingsService.triggerFormWebhook();
        } catch (error) {
            console.error('Failed to trigger form completion webhook:', error);
            return false;
        }
    }
    
    /**
     * Check if webhook has been triggered in current session
     */
    hasTriggeredInSession(): boolean {
        return !!sessionStorage.getItem('form_webhook_triggered');
    }
    
    /**
     * Reset session trigger (useful for testing)
     */
    resetSessionTrigger(): void {
        sessionStorage.removeItem('form_webhook_triggered');
    }
}

export const formWebhookService = FormWebhookService.getInstance();
export { FormWebhookService };
